<div class="new-portfolio-container">
  @if (preloaders.editDataFetching) {
    <div class="edit-preloader">
      <libero-preload-spinner></libero-preload-spinner>
    </div>
  } @else {
    @if (editId) {
      <div class="edit-overlay"></div>
    }
    <div class="container-fluid g-0">
      <div class="row g-0 desktop-padding">
        <div class="col-12 text-center">
          <div class="desktop-header">
            @if (!editId) {
              {{ 'newPortfolio.createNewPortfolio' | translate }}
            } @else {
              {{ 'global.portfolio' | translate }} "{{ editPortfolioName }}"
            }
          </div>
        </div>
        <div class="col-12 col-md-7 col-xl-8 order-md-2 pe-md-0 ps-md-4 ps-xl-5">
        <div class="row g-0 cards-margin justify-content-end h-100">
          <div class="col-12 desktop-content fixed-height-xl desktop-chart-layout">
            <!-- todo - duplicit elemnts for phone/desktop -->
            <div class="chart-label-container">
              <h2>{{ 'newPortfolio.investmentDevelopmentModel' | translate }}</h2>
              <libero-tooltip-button>
                {{ 'global.tooltips.investmentDevelopmentModel' | translate }}
              </libero-tooltip-button>
            </div>
            <div>
              @if (apiErrors.modelPortfolio || apiErrors.modelChart) {
                <div class="api-error-container">
                  {{ 'global.error.loadData' | translate }}
                </div>
              } @else {
                @if (!preloaders.modelChart && !preloaders.modelPortfolio) {
                  <div>
                    <libero-development-chart [chartData]="developmentChartData" [xLabels]="developmentChartLabels" [previewVideo]="previewVideo"></libero-development-chart>
                  </div>
                } @else {
                  <div class="model-chart-preload-container">
                    <libero-preload-spinner></libero-preload-spinner>
                  </div>
                }
              }
            </div>
            <div class="consult-with-new-container">
              @if (!editId) {
                <div class="new-portfolio-button-container">
                  <libero-button
                    [preloader]="preloaders.createPortfolio"
                    (click)="createPortfolio()"
                    label="{{ 'newPortfolio.createPortfolio' | translate }}"
                    btnClasses="btn--primary btn--heading"
                    data-cy="create-portfolio-button-desktop"
                  ></libero-button>
                </div>
              }
              <div class="additional-consult-button" data-cy="additional-consult-button-desktop">
                <p>
                  {{ 'newPortfolio.consultButtonDesc' | translate }}
                </p>
                <div
                  class="consult-link"
                  (click)="modalService.openConsultModal()"
                  (keydown.space)="modalService.openConsultModal()"
                  (keydown.enter)="modalService.openConsultModal()"
                  tabindex="0"
                  >
                  {{ 'global.iWantConsultation' | translate }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-12 col-md-5 col-xl-4 order-md-1 filtrations-container" [ngClass]="{'filtrations-container--highlighted': editId}">
        <div class="mobile-header">
          @if (!editId) {
            {{ 'newPortfolio.createNewPortfolio' | translate }}
          } @else {
            {{ 'global.portfolio' | translate }} "{{ editPortfolioName }}"
          }
        </div>
        @if (modelChartForm) {
          <div class="filters">
            <div class="filtration-label">
              {{ 'newPortfolio.filters.name' | translate }}
            </div>
            <libero-text-input
              [formName]="modelChartForm.controls['name']"
              placeholder="{{ 'newPortfolio.filters.namePlaceholder' | translate }}"
              data-cy="new-portfolio-name-input"
            ></libero-text-input>
            @if (!editId) {
              <libero-dip-picker
                [formName]="modelChartForm.controls['dip']"
                [availableContracts]="availableContracts"
                type="new-portfolio"
              ></libero-dip-picker>
            }
            <div class="filtration-label">
              {{ 'newPortfolio.filters.oneTimeDeposit' | translate }}
            </div>
            <libero-plus-minus-input
              [formName]="modelChartForm.controls['oneTimeDeposit']"
              [options]="{
                step: 500,
                displayUnits: getCurrencyFromCode(userService.loggedUser!.currencyCode),
                minValue: !!editId && savedInvestmentParams?.initialDeposit ? savedInvestmentParams!.initialDeposit : configService.getConfig(EnvironmentKeys.minimalInvest),
                maxValue: configService.getConfig(EnvironmentKeys.maximalInitialInvest),
                allowZero: !editId || savedInvestmentParams?.initialDeposit === 0 ? configService.getConfig(EnvironmentKeys.allowZeroInitialDeposit) : false
              }"
              [digitShortcutsOptions]="digitShortcutsOptions"
              [invalidClass]="bothInvestmentsZero"
              [autoSetMinIfLower]="true"
              [minusBtnTestId]="'portfolio-initial-deposit'"
            ></libero-plus-minus-input>
            <div class="filtration-label">
              {{ 'newPortfolio.filters.regularDeposit' | translate }}
            </div>
            <libero-plus-minus-input
              [formName]="modelChartForm.controls['regularDeposit']"
              [options]="{
                step: 500,
                displayUnits: getCurrencyFromCode(userService.loggedUser!.currencyCode),
                minValue: !!editId && savedInvestmentParams?.regularDeposit ? savedInvestmentParams!.regularDeposit : configService.getConfig(EnvironmentKeys.minimalInvest),
                maxValue: configService.getConfig(EnvironmentKeys.maximalRegularInvest),
                allowZero: !editId || savedInvestmentParams?.regularDeposit === 0 ? configService.getConfig(EnvironmentKeys.allowZeroRegularDeposit) : false
              }"
              [digitShortcutsOptions]="digitShortcutsOptions"
              [invalidClass]="bothInvestmentsZero"
              data-cy="regular-deposit-input"
              [autoSetMinIfLower]="true"
              [minusBtnTestId]="'portfolio-regular-deposit'"
            ></libero-plus-minus-input>

            <div class="regularity-radios-container">
              <libero-radio-input-group
                [availableValues]="availableInvestmentPeriods"
                [formName]="modelChartForm.controls['depositRegularity']"
                [cyId]="'portfolio-investment-frequency'"
              ></libero-radio-input-group>
            </div>

            @if (dipAvailable && modelChartForm.value.dip.dip) {
              <div class="dip-disclaimer">
                {{ 'newPortfolio.dipDisclaimer' | translate }}
              </div>
            }

            <div class="filtration-label filtration-label--tooltiped">
              {{ 'newPortfolio.filters.timeOfInvestment' | translate }}
              <libero-tooltip-button [explainPerson]="'jiri_mikes'">
                {{ 'global.tooltips.timeOfInvestment' | translate }}
              </libero-tooltip-button>
            </div>
            <libero-plus-minus-input
              [formName]="modelChartForm.controls['timeOfInvestment']"
              [options]="{
                step: 1,
                minValue: !!editId && savedInvestmentParams?.totalYearsToInvest ? savedInvestmentParams!.totalYearsToInvest : 1,
                maxValue: maxInvestmentLength,
                sliderStartAtLowestStep: true,
              }"
              [digitShortcutsOptions]="yearsShortcutsOptions"
              [autoSetMinIfLower]="true"
              [minusBtnTestId]="'portfolio-total-years-to-invest'"
            ></libero-plus-minus-input>
            <div class="filtration-label filtration-label--tooltiped">
              {{ 'newPortfolio.filters.riskProfile' | translate }}
              <libero-tooltip-button [explainPerson]="'monika_skodova'">
                {{ 'global.tooltips.suggestedRiskProfile' | translate }}
              </libero-tooltip-button>
            </div>
            <libero-slider-input
              [formName]="modelChartForm.controls['riskProfile']"
              [options]="sliderOptions"
              [disabled]="!!editId"
              data-cy="risk-score-slider-input"
            ></libero-slider-input>
            @if (!entryFeeCalcService.requestStatus.error) {
              @if (entryFeeToDisplay || entryFeeCalcService.requestStatus.preloader) {
                <div class="filtration-label filtration-label--tooltiped filtration-label--lg-pad" @fadeInOut>
                  <libero-entry-fee-calc
                    [entryFeeToDisplay]="entryFeeToDisplay"
                    [currencyCode]="userService.loggedUser?.currencyCode ?? 'CZK'"
                    [loading]="entryFeeCalcService.requestStatus.preloader"
                  ></libero-entry-fee-calc>
                </div>
              }
            } @else {
              <div class="fees-api-error-container" data-cy="fees-api-error-container">
                {{ 'global.error.entryFeeLoadError' | translate }}
              </div>
            }
          </div>
        }
      </div>
      @if (editId) {
        <div class="edit-button-container col-12 col-md-5 col-xl-4 order-md-3">
          <libero-button
            [preloader]="preloaders.editPortfolio"
            (click)="updatePortfolio()"
            label="{{ 'global.buttons.saveChanges' | translate }}"
            btnClasses="btn--primary btn--heading"
          ></libero-button>
          <libero-button
            [preloader]="preloaders.editPortfolio"
            (click)="discardChanges()"
            label="{{ 'global.buttons.discardChanges' | translate }}"
            btnClasses="btn--secondary btn--heading"
          ></libero-button>
        </div>
      }
      <div class="col-12 col-md-8 order-md-3 phone-content development-content-padding">
        <div class="rounded-corner-bg"><div class="rounded-corner"></div></div>
        <div class="chart-label-container">
          <h2>{{ 'newPortfolio.investmentDevelopmentModel' | translate }}</h2>
          <div>
            <libero-tooltip-button>
              {{ 'global.tooltips.investmentDevelopmentModel' | translate }}
            </libero-tooltip-button>
          </div>
        </div>
        <div>
          @if (apiErrors.modelPortfolio || apiErrors.modelChart) {
            <div class="api-error-container">
              {{ 'global.error.loadData' | translate }}
            </div>
          } @else {
            @if (!preloaders.modelChart && !preloaders.modelPortfolio) {
              <libero-development-chart [chartData]="developmentChartData" [xLabels]="developmentChartLabels"></libero-development-chart>
            } @else {
              <div class="model-chart-preload-container">
                <libero-preload-spinner></libero-preload-spinner>
              </div>
            }
          }
        </div>
      </div>
    </div>
    <div class="row g-0">
      <div class="col-12 phone-content development-content-padding">
        <!-- not in V1 -->
        <!-- <h4>
        {{ 'global.howProperlySetUpInvestment' | translate }}
      </h4>
      <div class="video-preview-container">
        <libero-video-preview [videoPreviewUrl]="'test'" [videoUrl]="'test'"></libero-video-preview>
      </div> -->
      @if (!editId) {
        <div class="new-portfolio-btn-container">
          <libero-button
            [preloader]="preloaders.createPortfolio"
            (click)="createPortfolio()"
            label="{{ 'newPortfolio.createPortfolio' | translate }}"
            btnClasses="btn--primary btn--heading"
            data-cy="create-portfolio-button-phone"
          ></libero-button>
        </div>
      }
      <div class="video-with-desc" data-cy="video-with-desc-phone">
        <p>{{ 'newPortfolio.videoButtonDesc' | translate }}</p>
        <div class="mt-3">
          <libero-video-preview [videoPreview]="previewVideo"></libero-video-preview>
        </div>
      </div>
      <div class="additional-consult-button" data-cy="additional-consult-button-phone">
        <p>
          {{ 'newPortfolio.consultButtonDesc' | translate }}
        </p>
        <div
          class="consult-link"
          (click)="modalService.openConsultModal()"
          (keydown.space)="modalService.openConsultModal()"
          (keydown.enter)="modalService.openConsultModal()"
          tabindex="0"
          >
          {{ 'global.iWantConsultation' | translate }}
        </div>
      </div>
    </div>
  </div>
</div>
<div class="container-fluid g-0 desktop-background">
  <div class="row g-0 desktop-padding pb-md-4">
    <div class="col-12 col-md-5 col-xl-4">
      <h3>
        {{ 'newPortfolio.portfolioContent' | translate }}
      </h3>
      @if (apiErrors.modelPortfolio) {
        <div class="api-error-container">
          {{ 'global.error.loadData' | translate }}
        </div>
      } @else {
        @if (!preloaders.modelChart && !preloaders.modelPortfolio) {
          <div class="instrument-cards-container"
            >
            <libero-instrument-chart-carousel
              [instrumentChart]="instrumentChart"
            ></libero-instrument-chart-carousel>
          </div>
        } @else {
          <div class="instrument-preload-container phone-content">
            <libero-preload-spinner></libero-preload-spinner>
          </div>
        }
      }
    </div>
    <div class="col-12 col-md-6 col-xl-7 offset-md-1">
      <div class="rounded-corner-bg rounded-corner-bg--reversed">
        <div class="rounded-corner rounded-corner--reversed"></div>
      </div>
      <div class="detailed-breakdown">
        <div class="breakdown-heading">
          {{ 'newPortfolio.detailedBreakdown' | translate }}
        </div>
        <div class="breakdown-table-header">
          <div class="heading">
            {{ 'newPortfolio.selectedInvestmentTools' | translate }}
          </div>
          <div class="heading heading--right">
            {{ 'newPortfolio.yieldLastYear' | translate }}
          </div>
        </div>
        @if (apiErrors.modelPortfolio) {
          <div class="api-error-container">
            {{ 'global.error.loadData' | translate }}
          </div>
        } @else {
          @if (!preloaders.modelChart && !preloaders.modelPortfolio) {
            <div class="list-container">
              <libero-dropdown-list [listData]="instrumentChart.chartData"></libero-dropdown-list>
            </div>
          } @else {
            <div class="instrument-preload-container phone-content">
              <libero-preload-spinner></libero-preload-spinner>
            </div>
          }
        }
        @if (!editId) {
          <div class="new-portfolio-btn-container">
            <libero-button
              [preloader]="preloaders.createPortfolio"
              label="{{ 'newPortfolio.createPortfolio' | translate }}"
              btnClasses="btn--primary btn--heading"
              (click)="createPortfolio()"
              data-cy="create-portfolio-button"
              >
            </libero-button>
          </div>
        }
      </div>
    </div>
  </div>
</div>
}
</div>
